import React, { Component } from 'react';
import ReactTable from 'react-table';
import XLSX from 'xlsx';
import debounce from 'lodash.debounce';
import Pagination from '@getgo/chameleon-react/dist/Pagination';
import { sessionsTableSkeletonScreen } from '../../../../SkeletonScreens/SkeletonScreen';
import './WebinarsTable.css';
import { connect } from 'react-redux';
import { denormalizeWebinars } from '../../../../Reducks/Webinars/WebinarsUtils';
import { CHECKBOX, VALUE_ADD } from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import {
  trackAnalyticsFeature,
  trackAnalyticsGenerateReportFeature
} from '../../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { XLS } from '../../../../Utils/Constants';
import { HeaderSortComponent } from '../../../../Scss/Custom/ReactTable/HeaderSortComponent';
import { actions } from '../../../../Reducks/AdminWebinars/index';
import {
  webinarIdFormatter,
  coorgsFormatter,
  dateFormatterWithTimezone,
  dateSorter,
  getWebinarsData,
  startTimeFormatter,
  startTimeSorter
} from '../../../../Utils/TableUtil';
import PropTypes from 'prop-types';
import SimpleSearchBox from '../../../../Components/SearchBox/SimpleSearchBox';
import Menu from '../../../../Components/Menu/Menu';
import DownloadIcon from '../../../../Components/Buttons/DownloadIcon';
import { getReportTypeMenuItems } from '../../../../Components/Menu/MenuItemsHelper';
import { getUnion } from '../../../../Utils/ArrayUtils';
import { AnswererRoles } from '../../../../Utils/Constants';
import { Badge, Tooltip } from 'reactstrap';

export class WebinarsTable extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    webinars: PropTypes.object,
    toggleWebinar: PropTypes.func,
    filterWebinars: PropTypes.func,
    toggleAllWebinars: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      isToolTipOpen: null
    };
  }

  getHeaders = () => {
    const { t } = this.context;
    const columns = this.getWebinarColumns();
    const header = [];
    columns.forEach(({ show, accessor }) => {
      if (accessor) {
        switch (accessor) {
          case WebinarsTableAccessor.NAME:
            header.push([t('tableHeaderColumns.name'), accessor]);
            break;
          case WebinarsTableAccessor.WEBINARID:
            header.push([t('tableHeaderColumns.webinarId'), accessor]);
            break;
          case WebinarsTableAccessor.ORGANIZER_NAME:
            header.push([t('tableHeaderColumns.organizers'), accessor]);
            break;
          case WebinarsTableAccessor.COORGANIZERS:
            header.push([t('tableHeaderColumns.coOrganizers'), accessor]);
            break;
          case WebinarsTableAccessor.DATE:
            header.push([t('tableHeaderColumns.date'), accessor]);
            break;
          case WebinarsTableAccessor.START_TIME:
            header.push([t('tableHeaderColumns.startTime'), accessor]);
            break;
          case WebinarsTableAccessor.REGISTRANTS:
            header.push([t('tableHeaderColumns.registrants'), accessor]);
            break;
          default:
            console.error('unexpected case');
            break;
        }
      }
    });
    return header;
  };

  getRecords = (webinarsData, headers) => {
    const data = [];
    const { filteredKeys } = this.props.webinars.webinars;
    webinarsData.forEach(webinar => {
      let row = [];
      if (filteredKeys.includes(webinar.webinarKey)) {
        headers.forEach(element => {
          switch (element) {
            case WebinarsTableAccessor.WEBINARID:
              row.push(webinarIdFormatter(webinar.webinarId, webinar.webinarKey));
              break;
            case WebinarsTableAccessor.COORGANIZERS:
              row.push(coorgsFormatter(webinar));
              break;
            case WebinarsTableAccessor.DATE:
              row.push(dateFormatterWithTimezone(webinar[element].dateTime, webinar[element].timeZone));
              break;
            case WebinarsTableAccessor.START_TIME:
              row.push(startTimeFormatter({ value: webinar[element] }));
              break;
            default:
              row.push(webinar[element]);
          }
        });
        data.push(row);
      }
    });
    return data;
  };

  exportFile = (webinarsData, id) => {
    const { t } = this.context;
    const fileName = t('webinars.registrationsReportName');
    const headers = this.getHeaders();
    const records = this.getRecords(webinarsData, headers.map(item => item[1]));
    const data = getUnion([headers.map(item => item[0])], records);
    const workBook = XLSX.utils.book_new();
    const dataSheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workBook, dataSheet);
    XLSX.writeFile(workBook, `${fileName}.${id === XLS ? 'xlsx' : 'csv'}`);
  };

  render() {
    const { fetching, webinars, filtering } = this.props.webinars;
    const filteredWebinars = denormalizeWebinars(webinars.filteredKeys, webinars.byKey);
    return (
      <div className="webinarsTableSection">
        {this.getSearchBox(filteredWebinars)}
        {fetching || filtering ? (
          sessionsTableSkeletonScreen()
        ) : (
          <React.Fragment>{this.getWebinarsTable(filteredWebinars)}</React.Fragment>
        )}
      </div>
    );
  }

  getSelectedPageWebinars = page => {
    const { user } = this.props.reduced_user;
    const { filter } = this.props.webinars;
    this.props.getWebinars(
      user.accountKey,
      filter.fromTime,
      filter.toTime,
      filter.creators,
      this.state.searchText,
      page,
      20,
      false
    );
  };

  fetchPage = (page = 1) => {
    this.getSelectedPageWebinars(page - 1);
  };

  fetchPageDebounced = debounce(this.fetchPage, 500);

  getWebinarsTable = filteredWebinars => {
    const { pagination, webinarsFetching } = this.props.webinars;
    const nextDisabled = typeof pagination.next !== 'number';
    const previousDisabled = typeof pagination.previous !== 'number';
    const showPagination = !(nextDisabled && previousDisabled);
    return (
      <div>
        <ReactTable
          keyField="webinarKey"
          data={getWebinarsData(filteredWebinars)}
          columns={this.getWebinarColumns()}
          defaultPageSize={filteredWebinars.length}
          minRows={5}
          loading={webinarsFetching}
          style={{ height: '270px' }}
          showPagination={false}
          className="-highlight"
          defaultSorted={[{ id: 'date', desc: true }]}
        />
        {showPagination && (
          <div className="pagination">
            <Pagination
              disableLast={false}
              key="event-pagination"
              lastPage={pagination.pageCount}
              nextDisabled={nextDisabled}
              onNextSelected={() => this.getSelectedPageWebinars(pagination.next)}
              onPageSelected={this.fetchPage}
              onPreviousSelected={() => this.getSelectedPageWebinars(pagination.previous)}
              pageIndex={pagination.page + 1}
              previousDisabled={previousDisabled}
            />
          </div>
        )}
      </div>
    );
  };

  getSearchBox = filteredWebinars => {
    const { mixpanelData, uniqueId } = this.props;
    const { t } = this.context;
    const { filter } = this.props.webinars;
    const { isBig } = this.props;
    const detailsDownloadMenu = [];
    const menuDownloadItems = getReportTypeMenuItems();
    const webinarsData = getWebinarsData(filteredWebinars);
    menuDownloadItems.map(item =>
      detailsDownloadMenu.push({
        onClick: () => this.exportFile(webinarsData, item.id),
        text: item.title,
        iconClassName: item.iconClass,
        id: item.id
      })
    );
    return (
      <div className="searchBoxContainer">
        <SimpleSearchBox
          searchString={filter.searchString}
          placeHolder={t('webinars.search')}
          onSearchInputChange={this.handleSearch}
          mixpanelData={mixpanelData}
        />
        <Menu
          isBig={isBig}
          menuKey={`download_${uniqueId}`}
          buttonName={t('buttons.downloadCamelCase')}
          detailsMenu={detailsDownloadMenu}
          buttonComponent={<DownloadIcon isBig={isBig} />}
        />
      </div>
    );
  };

  handleSearch = value => {
    this.setState({ searchText: value.trim() }, this.fetchPageDebounced);
  };

  getWebinarColumns = () => {
    const { t } = this.context;
    const { filteredSelectedWebinarKeys, filteredKeys } = this.props.webinars.webinars;
    return [
      {
        accessor: '',
        Header: this.checkBoxHeaderFormatter(filteredKeys.length, filteredSelectedWebinarKeys.length),
        Cell: this.checkBoxCellFormatter,
        sortable: false,
        width: 35,
        resizable: false,
        style: { textAlign: 'center' },
        headerStyle: { textAlign: 'center' }
      },
      {
        accessor: WebinarsTableAccessor.NAME,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.name')} />,
        minWidth: 150
      },
      {
        accessor: WebinarsTableAccessor.WEBINARID,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.webinarId')} />,
        Cell: this.webinarIdFormatter,
        minWidth: 100,
        sortable: false,
        headerStyle: { cursor: 'auto' }
      },
      {
        accessor: 'organizerName',
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.organizers')} />,
        Cell: this.organizerFormatter,
        minWidth: 100
      },
      {
        accessor: WebinarsTableAccessor.COORGANIZERS,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.coOrganizers')} />,
        Cell: this.coorganizerFormatter,
        minWidth: 120,
        sortable: false,
        headerStyle: { cursor: 'auto' }
      },
      {
        accessor: WebinarsTableAccessor.DATE,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.date')} />,
        Cell: cell => dateFormatterWithTimezone(cell.value.dateTime, cell.value.timeZone),
        sortMethod: dateSorter
      },
      {
        accessor: WebinarsTableAccessor.START_TIME,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.startTime')} />,
        Cell: startTimeFormatter,
        sortMethod: startTimeSorter
      },
      {
        accessor: WebinarsTableAccessor.REGISTRANTS,
        Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.registrants')} />
      }
    ];
  };

  toggleToolTip = tooltipId => {
    this.setState(prevState => ({
      isToolTipOpen: prevState.isToolTipOpen === tooltipId ? null : tooltipId
    }));
  };

  getCoorgDisplayTooltip = (coorgs, tooltipId) => {
    return (
      <Tooltip
        hideArrow
        autohide
        className="tooltipContainer"
        innerClassName="tooltipInnerContainer"
        isOpen={this.state.isToolTipOpen === tooltipId} // Unique tooltip state
        placement="right"
        target={tooltipId} // Use unique target ID
        toggle={() => this.toggleToolTip(tooltipId)} // Update toggle function
      >
        <span className="toolTipText">
          <div>
            {coorgs.map((name, index) => (
              <div key={index}>{name}</div>
            ))}
          </div>
        </span>
      </Tooltip>
    );
  };

  webinarIdFormatter = ({ original }) => {
    const webinarId = original.webinarId;
    const formattedId =
      original.webinarKey === original.webinarId ? '-' : webinarId.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');
    return <div>{formattedId}</div>;
  };

  organizerFormatter = ({ original }) => {
    return (
      <div>
        <div>{original.organizerName}</div>
        <div className="organizerEmail">{original.organizerEmail}</div>
      </div>
    );
  };

  coorganizerFormatter = ({ original, index }) => {
    const staffList = original.staff;
    const allowedRoles = [AnswererRoles.INTERNAL_ORGANIZER, AnswererRoles.EXTERNAL_ORGANIZER];

    const coorgs = staffList
      .filter(staff => allowedRoles.includes(staff.role) && staff.email !== original.organizerEmail)
      .map(staff => (staff.surName ? `${staff.givenName} ${staff.surName}` : staff.givenName));

    const remainingCoorgsLength = Math.max(coorgs.length - 1, 0);
    const isCoorgsMoreThanOne = coorgs.length > 1;
    if (!coorgs.length) {
      return '-';
    }

    const tooltipId = `coorgListBadge-${index}`; // Unique ID per row

    return (
      <div className="coorgCellContainer">
        {isCoorgsMoreThanOne && this.getCoorgDisplayTooltip(coorgs.slice(1), tooltipId)}
        <div className="coorgName">{coorgs[0]}</div>
        {isCoorgsMoreThanOne && (
          <div id={tooltipId}>
            <Badge color="secondary" className="badge">{`+${remainingCoorgsLength}`}</Badge>
          </div>
        )}
      </div>
    );
  };

  checkBoxHeaderFormatter = (totalCount, selectedCount) => {
    const checked = selectedCount !== 0;
    const isIntermediate = selectedCount !== 0 && selectedCount !== totalCount;
    const onCheck = e => {
      trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
      if (this.props.mixpanelData.reportType) {
        trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
      }
      this.props.toggleAllWebinars(e.target.checked);
    };
    const intermediate = input => {
      if (input) {
        input.indeterminate = isIntermediate;
      }
    };
    return <input type="checkbox" ref={intermediate} checked={checked} onChange={onCheck} />;
  };

  checkBoxCellFormatter = ({ original }) => {
    return (
      <input
        type="checkbox"
        checked={this.props.webinars.webinars.filteredSelectedWebinarKeys.includes(original.webinarKey)}
        onChange={e => {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
          if (this.props.mixpanelData.reportType) {
            trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
          }
          this.props.toggleWebinar(original.webinarKey, e.target.checked);
        }}
      />
    );
  };
}

export default connect(
  state => ({ webinars: state.reduced_admin_webinars, reduced_user: state.reduced_user }),
  {
    getWebinars: actions.getAdminWebinars,
    toggleWebinar: actions.toggleAdminWebinar,
    toggleAllWebinars: actions.toggleAllAdminWebinars
  }
)(WebinarsTable);

class WebinarsTableAccessor {
  static get NAME() {
    return 'name';
  }
  static get WEBINARID() {
    return 'webinarId';
  }
  static get ORGANIZER_NAME() {
    return 'organizerName';
  }
  static get COORGANIZERS() {
    return 'coOrganizers';
  }
  static get DATE() {
    return 'date';
  }
  static get START_TIME() {
    return 'startTime';
  }
  static get REGISTRANTS() {
    return 'registrants';
  }
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/Admin/Webinars/Table/WebinarsTable.js